import React, { useEffect, useState, useRef } from 'react';
import './libros_busq.css'
import { useTranslation } from 'react-i18next';
import Modalibro from '../../../components/modalLibro/ModalLibro';

const rut = 'https://www.ricardosalinas.com/images/libros/';

const Libros_busq = ({ contenido }) => {

    const [t, i18n] = useTranslation("biblioteca");

    const formatDate = (date) => {
        const options = { year: "numeric" };
        return new Date(date).toLocaleDateString(i18n.language, options);
    };

    const openVideoPopup = (videoId) => {
        setCurrentVideoId(videoId);
        setVideoPopupOpen(true);
      };
    
      const closeVideoPopup = () => {
        setVideoPopupOpen(false);
      };

    const [isModalOpen2, setIsModalOpen2] = useState(false);
    const [variable1, setVariable1] = useState('');
    const [variable2, setVariable2] = useState('');
    const [variable3, setVariable3] = useState('');
    const [variable4, setVariable4] = useState('');
    const [variable5, setVariable5] = useState('');
    const [variable6, setVariable6] = useState('');
    const [variable7, setVariable7] = useState('');
    const [variable8, setVariable8] = useState('');
    const [variable9, setVariable9] = useState('');

    const openModal2 = (value1, value2,value3, value4,value5, value6, value7, value8, value9) => {

        setVariable1(value1);
        setVariable2(value2);
        setVariable3(value3);
        setVariable4(value4);
        setVariable5(value5);
        setVariable6(value6);
        setVariable7(value7);
        setVariable8(value8);
        setVariable9(value9);
        setIsModalOpen2(true);
    };

    const closeModal2 = () => {
        setIsModalOpen2(false);
    };

    if (!contenido || !contenido.books || contenido.books.length === 0) {
        // Handle the case where `contenido` or `blogNs` is not available or is an empty array.
        return <div></div>;
      }

        return (
            <div id="bus_libros" className='libros_busq Libreria'>
                <div className='titulo_div'>
                <p className='tit1'>{(t('biblioteca.titulo'))}</p>
                </div>
                <div class="row2_bp escritorio">
                    <div class="list_content--items_bp">
                        {
                            contenido.books.map((item, index) => (
                                                <div class="card">
                                                    <div class="front">
                                                        <img class="imgG_bp" src={rut + item.imagen} alt={item.imagen.substring(0, item.imagen.length - 4)} />
                                                        <div class="cinta_bp">
                                                            <p class="tit_bp">{item.titulo.split(":")[0]}</p>
                                                        </div>
                                                    </div>

                                                    <div class="back">

                                                        {/* <p class="titu_bp">{item.titulo}
                                                            </p> */}
                                                        <p class="titu_bp">{item.titulo.split(":")[0]}
                                                        </p>
                                                        <p class="desc_bp">{item.descripcion.substring(0, 155) + '...'}
                                                        </p>
                                                        <p class="alineIzq_ub_bp aut_bp">{item.autor}
                                                        </p>
                                                        <p class="alineIzq_ub_bp daut_bp">{item.editorial}
                                                        </p>
                                                        <p class="alineIzq_ub_bp fh_bp"> {item.fecha.substring(6, 10)}  </p>

                                                        {/* <a class="buton_bp" target="_blank" href="#">Ver más</a> */}
                                                        <div class="div_bot1_bp">

                                                            <button class="buton_bp" onClick={() => openModal2(rut + item.imagen, item.imagen.substring(0, item.imagen.length - 4),
                                                            item.titulo, item.descripcion, item.autor, item.editorial, formatDate(item.fecha), item.blog, i18n.language)}>
                                                            <label>{t('biblioteca.ver-mas')}</label>
                                                            </button>
                                                        </div>
                                                    </div>
                                                </div>
                                            ))
                                        }
                                    
                    </div>
                    
                </div>
                <Modalibro
                isOpen={isModalOpen2}
                closeModal={closeModal2}
                variable1={variable1} //ruta con imagen
                variable2={variable2} //titulo
                variable3={variable3} //descripcion
                variable4={variable4} //autor
                variable5={variable5} //editorial
                variable6={variable6} //año
                variable7={variable7} //año
                variable8={variable8} //año
                variable9={variable9} //año

                // hdksjfjkds
            />
            </div>
        );
    
}

export default Libros_busq;